module.exports = __webpack_public_path__ + "static/media/Why-we-need-to-expand-our-crop-menu.f958da6e.jpg";